"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuardianResources = void 0;
const configurations_1 = require("./configurations");
const groups_1 = require("./groups");
const users_1 = require("./users");
exports.GuardianResources = {
    configurations: configurations_1.Configurations,
    users: users_1.Users,
    groups: groups_1.Groups,
};
//# sourceMappingURL=index.js.map